var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-row",
        { staticClass: "labelDiv" },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Área:")]),
            _c("span", [_vm._v(_vm._s(_vm.area) + " ha")])
          ]),
          _c("el-col", { staticClass: "inputDiv", attrs: { span: 8 } }, [
            _c("span", { staticClass: "label" }, [_vm._v("Perímetro:")]),
            _c("span", [_vm._v(_vm._s(_vm.perimetro) + " m")])
          ]),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("span", { staticClass: "label" }, [_vm._v("Município:")]),
              !_vm.municipios.length ? _c("span", [_vm._v("-")]) : _vm._e(),
              _vm._l(_vm.municipios, function(municipio) {
                return _c("span", [_vm._v(_vm._s(municipio.nome))])
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2504255e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2504255e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/InformacoesAreaArrecadacao.vue
// module id = null
// module chunks = 